import { useDispatch } from 'react-redux';

import { setProtocolAction } from '../redux/actions';
import { isFieldError, transformFieldErrors } from '../utils';

export function useStudyProtocolModal(props) {
  const { onClose } = props;

  const dispatch = useDispatch();

  const onCloseHandler = () => {
    onClose();
    dispatch(setProtocolAction({ error: null, loading: false }));
  };

  const getCustomErrors = (error) => {
    const fieldError = isFieldError(error);
    if (fieldError) return transformFieldErrors(error);

    return undefined;
  };

  return {
    getCustomErrors,
    onCloseHandler,
  };
}

export default useStudyProtocolModal;
